import { defineComponent } from "vue";
import OptionBaseControl from "./OptionBaseControl";
/**
 * @component
 */
export default defineComponent({
  name: "Autocomplete",
  extends: OptionBaseControl,
  computed:{
    displayPlaceholder(){
      return this.t("autocompletePlaceholder","_utility")
    }
  },
  methods: {
    inputFunction(e: any) {
      let value = e.target.value as string;
      if (this.config.minLength) {
        if (value.length >= (this.config.minLength as number)) {
          if (this.config.autocompleteFunction) {
            this.config.autocompleteFunction(this, value);
          } else {
            this.defaultAutocompleteFunction(value);
          }
        }
      }
    },
    defaultAutocompleteFunction(value: string) {
      console.log(value);
      if (this.state.options) {
        let options = this.state.options.filter((opt: any) => {
          return opt.Text.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .indexOf(
              value
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
            ) === -1
            ? false
            : true;
        }) as [ILookup];
        if (options && options.length > 0) {
          // set displayed options
          this.state.displayedOptions = options;
          this.openSelection();
        }
      }
    },
    findOption(value: string) {
      return this.state.options?.find((option: any) => option.Value === value || option.Text === value);
    },
  },
});
